import { Button } from "@tennr/frontend/components/Button";
import { Card } from "@tennr/frontend/components/Card";
import { motion } from "framer-motion";
import { useMobile } from "@tennr/frontend/hooks/useMobile";

interface PressCardAnimation {
  src: string;
  alt: string;
  url?: string;
  opacity: any;
  scale: any;
  delay: number;
  animated?: boolean;
}

interface PressCardProps {
  animation: PressCardAnimation;
  stagger?: number;
  variant?: "dark" | "light";
}

export const PressCard: React.FC<PressCardProps> = ({ animation, stagger = 0, variant }) => {
  const isMobile = useMobile();
  // if not animated, render a simple div without motion
  if (!animation.animated) {
    return (
      <Card className="press-card" variant={variant}>
        <img className="publication-logo" alt={animation.alt} src={animation.src} draggable={false} />
      </Card>
    );
  }

  return (
    <motion.div
      className="press-card"
      key={animation.src}
      style={{
        opacity: animation.opacity,
        scale: animation.scale,
      }}
      initial={{ opacity: 0, y: 24, x: -24, scale: 1.05 }}
      animate={{ opacity: 1, y: 0, x: 0, scale: 1 }}
      exit={{ opacity: 0, y: -24, x: -24, scale: 1.05 }}
      transition={{
        duration: 0.6,
        ease: "easeOut",
        delay: animation.delay + stagger,
      }}
    >
      <Card className="press-card" variant={variant}>
        <Button minHeight={isMobile ? 53 : 78} minWidth={isMobile ? 100 : 173} staticBackgroundColor="#EEDFD1CC" isCard={true}>
          {animation.url ? (
            <a href={animation.url} target="_blank" rel="noreferrer noopener" className="press-link">
              <img className="publication-logo" alt={animation.alt} src={animation.src} draggable={false} />
            </a>
          ) : (
            <img className="publication-logo" alt={animation.alt} src={animation.src} draggable={false} />
          )}
        </Button>
      </Card>
    </motion.div>
  );
};
